"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: (0, _mui.alpha)(theme.palette.common.white, 0.5),
        backdropFilter: 'blur(5px)',
        zIndex: 3
    };
});
const Loading = (param)=>{
    let { isLoading } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        "data-testid": getTestId(_constants.FACET_FILTER_LOADING),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {})
    });
};
exports.Loading = Loading;
